/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
  mtgBody,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputText from "components/ui/input/InputText";

import { formatTelNumber } from "utilities/formater";

/**
 * 携帯電話番号
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} maxLength 最大文字数
 * @param {String} message メッセージ
 * @param {String} txtCaption 注釈
 */
const PhoneNo = memo(({ required, maxLength, message, txtCaption }) => {

  return (
    <div css={mtgGroup}>
      {/** ラベル */}
      {/** MEMO：携帯電話または固定電話片方が必須のため、任意項目だが任意ラベルは表示しない */}
      <LabelWithOptionIcon required={true}>
        携帯電話番号
      </LabelWithOptionIcon>
      {/** MEMO:通常のmtgBodyとmarginBottomが違うため直書き */}
      <p css={mtgBody} style={{ marginBottom: '12px' }}>{message}</p>
      <InputText
        name="phoneNo"
        placeholder="09012345678"
        inputMode="numeric"
        maxLength={maxLength}
        pairNumber="telNo"
        rules={{
          required: {
            value: required,
            message: "携帯電話番号を入力してください。",
          },
          pattern: {
            value: /^0[9876]0[-]?\d{4}[-]?\d{4}$/,
            message: "携帯電話番号の形式が正しくありません。",
          },
        }}
        telNoValid={{
          formatTelNumber,
          message: "携帯電話番号の形式が正しくありません。",
        }}
        isTelNo={true}
      ></InputText>
      <p css={mtgCaption}>{txtCaption}</p>
    </div>
  );
});

export default PhoneNo;
